'use client';

import { Responsive, WidthProvider } from 'react-grid-layout';
import './style.css';

export const ResponsiveGridLayout: any = WidthProvider(Responsive);
